module.exports = __webpack_public_path__ + "static/media/image-gallery-3.47e20c6f.jpg";